/**
 * Modal for å bli med i konkurranse
 */

import React, { useState } from 'react';
import { XCircle } from 'lucide-react';
import { joinCompetition } from '../services/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../services/firebase';

const functions = getFunctions(app);

export const JoinCompetitionModal = ({ 
  onClose, 
  userId,
  onSuccess 
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const code = e.target.code.value.toUpperCase().trim();
      
      // Bruk Cloud Function for å finne konkurransen
      const findCompetitionByCode = httpsCallable(functions, 'findCompetitionByCode');
      const result = await findCompetitionByCode({ code });
      const competitionInfo = result.data;
      
      // Bli med i konkurransen
      await joinCompetition(competitionInfo.id, userId, competitionInfo);
      onSuccess(competitionInfo.id);
      onClose();
    } catch (error) {
      console.error('Error joining competition:', error);
      alert(error.message || 'Kunne ikke bli med i konkurranse');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-md z-50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-sm rounded-[3rem] p-8 shadow-2xl animate-in zoom-in duration-300">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-black text-slate-800 tracking-tight">
            Bli med
          </h2>
          <button 
            onClick={onClose}
            className="text-slate-300 hover:text-slate-500"
          >
            <XCircle className="w-8 h-8" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <p className="text-[10px] text-slate-400 text-center font-bold px-4 leading-relaxed uppercase tracking-tight italic">
            Skriv koden fra den som har opprettet gruppen
          </p>

          <input
            name="code"
            required
            maxLength={10}
            className="w-full p-6 bg-slate-50 rounded-2xl border-2 border-slate-100 focus:border-orange-500 outline-none text-center font-black tracking-[0.2em] text-2xl uppercase shadow-inner"
            placeholder="KODE"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 bg-orange-600 text-white font-black rounded-2xl shadow-lg shadow-orange-100 hover:bg-orange-700 active:scale-95 transition-all uppercase tracking-widest text-[11px] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Søker...' : 'Gå til LØP'}
          </button>
        </form>
      </div>
    </div>
  );
};
